/**
 * UUID v7 – zeitgeordnet.
 *
 * Zwei Gründe gegen v4: der Ausgangskorb wird nach Kennung sortiert und soll
 * dabei der Erfassungsreihenfolge folgen, und zeitgeordnete Schlüssel
 * fragmentieren den Datenbankindex deutlich weniger als zufällige.
 *
 * Aufbau nach RFC 9562: 48 Bit Zeitstempel in Millisekunden, 4 Bit Version,
 * 12 Bit Zufall, 2 Bit Variante, 62 Bit Zufall.
 */

function randomBytes(n: number): Uint8Array {
  const out = new Uint8Array(n)
  crypto.getRandomValues(out)
  return out
}

let lastMs = 0
let sequence = 0

export function uuidv7(): string {
  let ms = Date.now()
  // Mehrere Kennungen in derselben Millisekunde müssen trotzdem in der
  // Erfassungsreihenfolge sortieren – sonst stimmt die Reihenfolge im
  // Ausgangskorb bei schnellen Eingaben nicht.
  if (ms === lastMs) {
    sequence = (sequence + 1) & 0x0fff
    if (sequence === 0) ms = ++lastMs
  } else {
    lastMs = ms
    sequence = randomBytes(2)[0] & 0x0f
  }

  const bytes = new Uint8Array(16)
  bytes[0] = (ms / 2 ** 40) & 0xff
  bytes[1] = (ms / 2 ** 32) & 0xff
  bytes[2] = (ms / 2 ** 24) & 0xff
  bytes[3] = (ms / 2 ** 16) & 0xff
  bytes[4] = (ms / 2 ** 8) & 0xff
  bytes[5] = ms & 0xff

  bytes[6] = 0x70 | ((sequence >> 8) & 0x0f) // Version 7
  bytes[7] = sequence & 0xff

  const rest = randomBytes(8)
  bytes.set(rest, 8)
  bytes[8] = (bytes[8] & 0x3f) | 0x80 // Variante

  const hex = [...bytes].map((b) => b.toString(16).padStart(2, '0')).join('')
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`
}

/** Zeitstempel aus einer v7-Kennung, für Diagnose und Sortierung. */
export function uuidv7Time(id: string): number {
  const hex = id.replace(/-/g, '').slice(0, 12)
  return parseInt(hex, 16)
}
